export default __webpack_public_path__ + "static/media/download.d64b65ad.svg";